module.exports = __webpack_public_path__ + "static/img/pictureB.2c298ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/pictureB.jpg
// module id = 2VqO
// module chunks = 0